import { Events } from 'yuzu-utils'

export default new Events()